import { DendromapLoader } from '@repo/ui/components/dendromap-loader';
import { lazy, Suspense } from 'react';
import { DashboardLayout } from '@repo/ui/components/dashboard-layout';

const AlertsManagement = lazy(() =>
  import('@repo/ui/features/alerts/index').then((mod) => ({ default: mod.AlertsManagement })),
);

export default function AlertsPage() {
  return (
    <Suspense fallback={<DendromapLoader message="Chargement des alertes..." />}>
      <AlertsManagement />
    </Suspense>

  );
}

